// extracted by mini-css-extract-plugin
export default {"canvas":"SensitiveDataMask-module__canvas"};